import { jsx as _jsx } from "react/jsx-runtime";
import { DeviceProvider, Devices } from "@madmedical/ui";
import { useDismissPersist } from "@madmedical/storage";
import useDevices from "../useDevices";
const AllDevices = () => {
    const { devices, isLoading } = useDevices();
    const { /*visible: webshopAlertVisible,*/ dismiss: dismissWebshopalert } = useDismissPersist("webshopAlert");
    if (isLoading) {
        return null;
    }
    return (_jsx(DeviceProvider, Object.assign({ value: { devices } }, { children: _jsx(Devices, { showWebshopAlert: false, onDismissWebshopAlert: dismissWebshopalert }) })));
};
export default AllDevices;
